jQuery(document).ready(function($){
	$('.contact-form.collapsed-form .form-control').keypress(function() {
		$(this).closest('.contact-form.collapsed-form').find('.collapse-block').slideDown();
		$(this).closest('.contact-form.collapsed-form').removeClass('collapsed-form');
	});
	
	$("#main-nav").sticky({topSpacing:0});
		
	$("[placeholder]").textPlaceholder();
	
	(function() {
		var $wrap = $('.wrap-in'),
			TIMEOUT = 300,
			$btn = $('.btn-menu');
		
		$wrap.append('<span class="overlay"></span>');
		
		$btn.click(function() {
			$(this).toggleClass('active');
			$('body').toggleClass('push');
			
			return false;
		});
		
		$(document).on('click', '.overlay', function() {
			$btn.click();
		});
		
	})();
	
	$("#main-nav li").has("ul").addClass("has-drop");
	
	$("#main-nav ul > .has-drop").append('<span class="opener"></span>');
	
	$('#main-nav .has-drop > .opener').click(function(){
		$(this).siblings('ul').slideToggle();
		$(this).closest('li').toggleClass('active');
		$(this).closest('li').siblings('.active').removeClass('active').children('ul').slideUp();
	});
	
	function mapInitialize(map_) {
		var coords_ = $('#'+ map_).data('coords');
			if (coords_){
				var latitude = coords_.split(',')[0];
				var longtitude = coords_.split(',')[1];
			}
			
		
		var latlng = new google.maps.LatLng(latitude,longtitude);
		
		var myOptions = {
			zoom: 15,
			center: latlng,
			disableDefaultUI: true,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		};
		
		var map = new google.maps.Map(document.getElementById(map_), myOptions);
		
		var marker = new google.maps.Marker({
			position: latlng,
			map: map
		});
	}
	$('.map').each(function(){
		var map_ = $(this).attr('id');
		mapInitialize(map_);
	});
	$('#footer .bottom .by .ico-by').clone().appendTo('#footer .bottom .by .mobile-ico');
	$('<span class="sep visible-xs"><span></span></span>').appendTo('.footer-nav li + li');
	if (!Modernizr.svg) {
		$('img[src*="svg"]').attr('src', function() {
			return $(this).attr('src').replace('.svg', '.png');
		});
	};
	$('.info .holder .logos').clone().appendTo('.info .logos-holder');
	$('.info-box .collapse-block').not('.info-box.open .collapse-block').hide();
	$('.info-box .btn-open').click(function(){
		$(this).closest('.cols').find('.info-box .collapse-block').not($(this).closest('.info-box').find('.collapse-block')).slideUp();
		$(this).closest('.cols').find('.info-box').not($(this).closest('.info-box')).removeClass('open');
		$(this).closest('.info-box').find('.collapse-block').slideToggle();
		$(this).closest('.info-box').toggleClass('open');
		return false;
	});
	
	$('.faq .collapse-block').not('.faq .open .collapse-block').hide();
	$('.faq > li > h2').click(function(){

		var _this = $(this);

		$(this).closest('.faq').find('.collapse-block').not($(this).closest('li').find('.collapse-block')).slideUp();
		$(this).closest('.faq').find('> li').not($(this).closest('li')).removeClass('open');
		$(this).closest('li').find('.collapse-block').slideToggle(function()
		{
			$.scrollTo(_this,150,{offset: -100});
		});
		$(this).closest('li').toggleClass('open');

		
		return false;
	});
	
	$('.accordion > li').each(function(){
		if($(this).hasClass('active')) {
			$(this).find('.collapse').slideDown(0);
		}
	});
	
	$('#accordion-1 .opener').click(function(){
		$(this).siblings('.collapse').slideToggle();
		$(this).parent('li').toggleClass('active');
		$(this).parent('li').siblings('.active').removeClass('active').children('.collapse').slideUp();
	});
	
	$('#accordion-2 .opener').click(function(){
		$(this).siblings('.collapse').slideToggle();
		if (!$(this).parent('li').hasClass('map-activated')){
			var map_ = $(this).siblings('.collapse').find('.map').attr('id');
			mapInitialize(map_);
		}
		$(this).parent('li').addClass('map-activated');
		$(this).parent('li').toggleClass('active');
		$(this).parent('li').siblings('.active').removeClass('active').children('.collapse').slideUp();
		return false;
	});
	
	$('.facts-carousel').slick({
		dots: false,
		infinite: true,
		speed: 500,
		useCSS: false
	});
	
	$('.logos-carousel').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 6,
		slidesToScroll: 1,
		centerMode: false,
		variableWidth: true,
		useCSS: false,
		centerMode: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					variableWidth: false
				}
			}
		]
	});
	
	$('.cases-slider').slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 500,
		fade: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		useCSS: false,
		centerMode: false,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 991,
				settings: {
					arrows: false
				}
			}
		]
	});
	$('.cases-slider .slick-prev, .cases-slider .slick-next').wrapAll('<div class="direction-nav"></div>');
		
	$(window).load(function() {
		equalheight('.info .info-box.eq-height');
	});
	$(window).resize(function(){
		equalheight('.info .info-box.eq-height');
	});

});
